import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import MissionSection from './components/MissionSection';
import InterviewTeaser from './components/InterviewTeaser';
import CaureTeaser from './components/CaureTeaser';
import ServicesSection from './components/ServicesSection';
import UpcomingEventSection from './components/UpcomingEventSection';
import AudienceSection from './components/AudienceSection';
import ProcessSection from './components/ProcessSection';
import EventSection from './components/EventSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import InterviewPage from './pages/InterviewPage';
import TeamPage from './pages/TeamPage';
import CaureInterviewPage from './pages/CaureInterviewPage';
import InterviewsPage from './pages/InterviewsPage';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#1a1c1b]">
      <Header />
      <main>
        <HeroSection />
        <MissionSection />
        <InterviewTeaser />
        <CaureTeaser />
        <ServicesSection />
        <UpcomingEventSection />
        <AudienceSection />
        <ProcessSection />
        <EventSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/interview-ambassadeur" element={<InterviewPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/interview-vincent-caure" element={<CaureInterviewPage />} />
            <Route path="/interviews" element={<InterviewsPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
